import { render } from "./infoOfOversight.vue?vue&type=template&id=c520de90"
import script from "./infoOfOversight.vue?vue&type=script&lang=js"
export * from "./infoOfOversight.vue?vue&type=script&lang=js"

import "./infoOfOversight.vue?vue&type=style&index=0&id=c520de90&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__